import { AsyncThunk } from '@reduxjs/toolkit';
import { AppState } from 'app/store';
import { Link } from 'types/api.types';
import { ProfileCard } from 'types/profile';
import { SharedLink, _SharedLinks } from 'types/shares.types';
import { SongStatusType } from 'types/song';

export enum ShareType {
  AUDIO = 'AUD',
  PLAYLIST = 'PLS',
}

export interface ShareServiceResponse {
  response: {
    _links: {
      getPublicShare?: Link;
      getPublicShareV2?: Link;
    };
  };
}

export interface AudioShare {
  guid: string;
  title: string;
  duration: number;
  _links: {
    playAudio: Link;
    downloadAudio?: Link;
    getDesktopWaveform: Link;
    getMobileWaveform: Link;
  };
}

export interface Share {
  createdBy: {
    userGuid: string;
    profileCard: ProfileCard;
  };
  shareToken: string;
  type: ShareType;
  referralId?: string;
  _links: {};
}

export interface ShareResponse {
  response: {
    config?: {
      item: {
        referralId: string;
      };
    };
    share: {
      item: Share;
    };
    audio: {
      item: AudioShare;
    };
    song: {
      item: {
        guid: string;
        title: string;
        status: SongStatusType;
      };
    };
  };
}

export type GetSharedListEffectProps = AsyncThunk<
  {
    items: SharedLink[];
    _links: _SharedLinks;
  },
  {
    guid: string;
    next?: Link;
  },
  {
    state: AppState;
  }
>;
